var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeesLeftnav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9996 13.0002C20.485 13.0002 22.4997 10.9855 22.4997 8.50011C22.4997 6.01477 20.485 4 17.9996 4C15.5143 4 13.4995 6.01477 13.4995 8.50011C13.4995 10.9855 15.5143 13.0002 17.9996 13.0002Z",
    stroke: "#7889B3",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9995 28.0009H8.99902V26.0008C8.99902 23.6138 9.94726 21.3246 11.6351 19.6367C13.323 17.9488 15.6122 17.0006 17.9992 17.0006C20.3863 17.0006 22.6755 17.9488 24.3634 19.6367C26.0512 21.3246 26.9995 23.6138 26.9995 26.0008V28.0009Z",
    stroke: "#7889B3",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9985 4C26.192 4 27.3367 4.47412 28.1806 5.31805C29.0245 6.16199 29.4986 7.30661 29.4986 8.50011C29.4986 9.69361 29.0245 10.8382 28.1806 11.6822C27.3367 12.5261 26.192 13.0002 24.9985 13.0002",
    stroke: "#7889B3",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0015 4C9.80796 4 8.66334 4.47412 7.81941 5.31805C6.97547 6.16199 6.50135 7.30661 6.50135 8.50011C6.50135 9.69361 6.97547 10.8382 7.81941 11.6822C8.66334 12.5261 9.80796 13.0002 11.0015 13.0002",
    stroke: "#7889B3",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1987 17.3802C29.9024 18.0284 31.3692 19.1785 32.4049 20.6785C33.4406 22.1785 33.9965 23.9576 33.9989 25.7805V28.0005H30.9988",
    stroke: "#7889B3",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80127 17.3802C6.09756 18.0284 4.6308 19.1785 3.59509 20.6785C2.55938 22.1785 2.00354 23.9576 2.00113 25.7805V28.0005H5.0012",
    stroke: "#7889B3",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesLeftnav);
export default __webpack_public_path__ + "static/media/employees-leftnav.ad95011572ea6b0900cce44f7d4360bd.svg";
export { ForwardRef as ReactComponent };